// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4b0e9390","667":"990a8dea"}[chunkId] + ".chunk.js";
};